export default __webpack_public_path__ + "static/media/office2-afterB-768w.0774815a.webp";